module.exports = __webpack_public_path__ + "static/img/maize-sens2050-v2-lowres.66e8417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maps/maize-sens2050-v2-lowres.png
// module id = xMng
// module chunks = 1